module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/calendar-4296726db058b046a2de35dc5049a16c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/calendar.svg
// module id = Gt0H
// module chunks = 24